module.exports = __webpack_public_path__ + "static/STEMI_Withdrawal_Form_ENG-eba3a70bc62a6279f92e060f9de3f9eb.pdf";